import { useEffect, useState } from 'react';

// Define constants for item and link IDs
const ITEM_IDS = {
  MORE: 'more',
  ALTSAFE: 'altsafe'
};

const LINK_IDS = {
  RELATIONSHIP_MANAGER: 'relationship-manager',
  PREFERENCE: 'preference',
  MY_REFERRALS: 'my-referrals',
  TAX_OPTIMISER: 'tax-optimiser'
};

// Function to filter 'relationship-manager' link
const filterRelationshipManagerLink = (items, investorCache) => {
  if (!investorCache?.rmDetails) {
    return items.map((item) => {
      if (item.id === ITEM_IDS.MORE && item.moreLinks) {
        item.moreLinks = item.moreLinks.filter((link) => link.id !== LINK_IDS.RELATIONSHIP_MANAGER);
      }
      return item;
    });
  }
  return items;
};

// Function to remove the 'preference' link and highlight the 'altsafe' item
// altSafe is shown to every logged in investor, so it is no longer gated on showJiraafSafe
const filterPreferenceLink = (items, investorCache) => {
   // Check if there is a wallet balance and add highlight to altSafe
  if (investorCache?.hasWalletBalance) {
      items = items.map((item) => {
          if (item.id === ITEM_IDS.ALTSAFE) {
              item.highlight = true;
          }
          return item;
      });
  }
  return items;
};

// Function to filter 'my-referrals' link
const filterMyReferralsLink = (items, investorCache) => {
  if (!investorCache.showReferral) {
    return items.map((item) => {
      if (item.id === ITEM_IDS.MORE && item.moreLinks) {
        item.moreLinks = item.moreLinks.filter((link) => link.id !== LINK_IDS.MY_REFERRALS);
      }
      return item;
    });
  }
  return items;
};

// Function to filter 'tax-optimizer' link
const filterTaxOptimiserLink = (items, isEligibleForTaxProducts, isLinkedToPartner) => {
  if (!isEligibleForTaxProducts || isLinkedToPartner) {
    return items.map((item) => {
      if (item.id === ITEM_IDS.MORE && item.moreLinks) {
        item.moreLinks = item.moreLinks.filter((link) => link.id !== LINK_IDS.TAX_OPTIMISER);
      }
      if (item.id === ITEM_IDS.MORE) {
        item.newFeatureHighlight = isEligibleForTaxProducts && !isLinkedToPartner;
      }

      return item;
    });
  }
  return items;
};

const PARTNER_HIDDEN_LINK_IDS = ['reinvestments'];

const filterPartnerLinkedItems = (items) => {
  return items.map((item) => {
    if (item.id === ITEM_IDS.MORE && item.moreLinks) {
      item.moreLinks = item.moreLinks.filter((link) => !PARTNER_HIDDEN_LINK_IDS.includes(link.id));
    }
    return item;
  });
};

const useBottomNavigation = ({ investorCache, defaultNavItems, isEligibleForTaxProducts, isLinkedToPartner }) => {
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    const filterNavItems = () => {
      let newNavItemList =  JSON.parse(JSON.stringify(defaultNavItems));
      newNavItemList = filterRelationshipManagerLink(newNavItemList, investorCache);
      newNavItemList = filterPreferenceLink(newNavItemList, investorCache);
      newNavItemList = filterMyReferralsLink(newNavItemList, investorCache);
      newNavItemList = filterTaxOptimiserLink(newNavItemList, isEligibleForTaxProducts, isLinkedToPartner);
      if (isLinkedToPartner) {
        newNavItemList = filterPartnerLinkedItems(newNavItemList);
      }

      setNavItems(newNavItemList);
    };

    filterNavItems();
  }, [investorCache, isLinkedToPartner]);

  return navItems;
};

export default useBottomNavigation;